import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { useNavigate } from 'react-router-dom'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import URL from '../../constants/urls'
import { globalKeyStore } from '../../redux/actions/globalState'
import EventCard from '../../components/global/EventCard'
import { convertParkingTime } from '../../utils/helper'
import { useParams } from 'react-router-dom'

function BookingList({ eventData, noOfEventShow, dispatch, isMainScreen }) {
    // console.log(eventData, 'eventData')
    const user = window.location.toString().split('/')[3]
    const navigate = useNavigate()
    const {facility} = useParams()
    const sliceEvent = eventData?.slice(0, noOfEventShow)
    const localFacilityId = JSON.parse(localStorage.getItem('selectedFacilityId'))
    const [facilityDet, setFacilityDet] = useState({
        name: null,
        defaultPrice: '0.00'
    })

    const handleBookingButtton = (id, end_time='') => {
        localStorage?.setItem('selectEventType', 'event')
        localStorage?.setItem('booking_event', id)
        dispatch(globalKeyStore({ selectedEventId: id }))
        // console.log(end_time, 'end_time')
        if(end_time) {
            localStorage.setItem('end_time', end_time)
        }
        if (user) {
            // navigate(`/${user}/${URL?.BOOKING_PAGE}/${id}`) // Old functionality
            // navigate(`/${user}/${URL?.BOOKING_DETAIL}`)
            // navigate(`/${user}/${URL?.FACILITY_BOOKING_DETAIL}`)
            if(facility){
                navigate(`/${user}/${facility}/${URL?.BOOKING_DETAIL}`)
            }else{
                navigate(`${URL?.BOOKING_DETAIL}`)
            }
        } else {
            navigate('*')
        }
    }
    useEffect(() => {
        if(eventData?.length > 0 && eventData[0]?.facilities?.length) {
            let facilityName = eventData[0].facilities.filter((item) => item.id === localFacilityId )
            if(facilityName.length > 0) {
                setFacilityDet({...facilityDet, defaultPrice: facilityName[0].base_event_rate, name: facilityName[0].full_name})
            }
        }
    }, [])

    return (

        (sliceEvent?.length > 0) ? sliceEvent?.map((item) =>
            <EventCard
                key={item?.id}
                handleBookingButtton={handleBookingButtton}
                imageUrl={(item?.image_url) ? item?.image_url : 'NoImage'}
                title={item?.title}
                detials={item?.description}
                startDate={item?.start_time}
                time={convertParkingTime(item?.parking_start_time, item?.parking_end_time)}
                paybaleAmount={(item?.event_rate === '0.00' || item?.event_rate === 0) ? item?.facilities?.[0]?.base_event_rate : item?.event_rate }
                id={item?.id}
                isMainScreen={(isMainScreen) ? isMainScreen : false}
                facilitiesName={facilityDet.name ? facilityDet.name : item?.facilities?.[0]?.full_name}
                facilityPrice={facilityDet.defaultPrice}
                end_time={item?.end_time}
            />
        ) : <h4 className='w-100 text-primary py-3 text-center'>No events available.</h4>
    )
}

BookingList.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    globalData: PropTypes.object,
    eventData: PropTypes.array,
    noOfEventShow: PropTypes.number,
    isMainScreen: PropTypes.bool
}

BookingList.defaulProps = {
    dispatch: noop,
    globalData: EMPTY_OBJECT,
    notify: noop,
    eventData: EMPTY_ARRAY,
    noOfEventShow: 4,
    isMainScreen: false
}


function mapStateToProps({ globalReducers }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        eventData: globalReducers?.eventData,
        noOfEventShow: globalReducers?.noOfEventShow
    }
}

export default connect(mapStateToProps)(BookingList)